import { BaseTheme } from "./BaseTheme";
import { ITheme } from "./ThemeTypes";

export const LightTheme: ITheme = {
  name: "LightTheme",
  base: BaseTheme,
  colors: {
    outline: "116, 119, 127",
    outline_variant: "196, 198, 207",
    surface: "248, 250, 250",
    surface_container: "236, 238, 239",
    surface_container_high: "230, 232, 233",
    on_surface_variant: "67, 71, 78",
    on_surface: "25, 28, 29",
    primary: "35, 95, 166",
    on_primary: "255, 255, 255",
    primary_container: "213, 227, 255",
    on_primary_container: "0, 27, 60",
    secondary_container: "255, 226, 67",
    on_secondary_container: "33, 27, 0",
    surface_variant: "224, 226, 236",
    tertiary_container: "255, 218, 213",
    on_tertiary_container: "65, 0, 1",
    on_surface_variant_opacity_0_08: "rgba(73, 69, 78, 0.08)",
    inverse_surface: "45, 49, 49",
    inverse_on_surface: "239, 241, 241",
    scrim: "0, 0, 0",
    error: "192, 0, 12",
  },
  opacity: {
    opacity_percent_1: 40,
  },
};
